<template>
  <div class="grade-history-component">
    <div class="py-4 centering" v-if="loading">
      <b-spinner variant="primary" />
    </div>
    <ul v-else>
      <li v-for="(item, index) in modules" :key="index">
        <div
          id="dropdown-label"
          class="d-flex align-items-center py-3"
          v-b-toggle="item.id"
        >
          <i class="icon-chevron-down mx-3"></i>
          <h4>{{ item.name }}</h4>
        </div>
        <loading :show="loading">
          <b-collapse class="dropdown-content" :id="item.id">
            <grade-history-item :moduleId="item.id" />
            <div v-if="item.sub_modules">
              <ul>
                <li
                  v-for="(subItem, subIndex) in item.sub_modules"
                  :id="subItem.id"
                  :key="subIndex"
                  class="py-2"
                >
                  <div
                    id="dropdown-label"
                    class="d-flex align-items-center submodule py-1 mb-2"
                    v-b-toggle="subItem.id"
                  >
                    <i class="icon-chevron-down mr-3"></i>
                    <h4>{{ subItem.name }}</h4>
                  </div>
                  <b-collapse class="px-3 pb-2" :id="subItem.id">
                    <grade-history-item :moduleId="subItem.id" />
                  </b-collapse>
                </li>
              </ul>
            </div>
          </b-collapse>
        </loading>
      </li>
    </ul>
  </div>
</template>

<script>
import GradeHistoryItem from "@/components/account/GradeHistoryItem.vue";
import { mapState } from "vuex";
export default {
  components: { GradeHistoryItem },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState("modules", ["modules"])
  }
};
</script>
<style lang="scss" scoped>
.grade-history-component {
  h4 {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 0;
  }

  i {
    font-size: 16px;
    font-weight: 900;
    line-height: 20px;
  }

  ul {
    list-style-type: none;
    padding-left: 0;
  }

  li {
    transition: 0.5s all;
    font-size: 14px;
    font-weight: normal;
    & div#dropdown-label.not-collapsed {
      &.submodule {
        background-color: transparent;
      }

      .icon-chevron-down:before {
        display: flex;
        transform: rotate(180deg);
      }
    }
    &:has(div.submodule) {
      &:has(div.not-collapsed) {
        border-bottom: none;
        li:first-child {
          &:has(div.not-collapsed) {
            border-bottom: 1px solid #353945;
          }
        }
      }
    }
  }
  .dropdown-content {
    padding: 0px 32px 8px;
    background-color: rgba(105, 106, 126, 0.04);
  }
}
</style>
